<div *ngIf="isLoading | async" class="overlay" id = "loader">
      <div class="spinner"></div>
  </div>
  
  <div *ngIf="isLoadingText | async" class="overlayText">
    <div class="spinnerText">
      <em>Please wait while your video is being uploaded. This may take some time. Please do not refresh the page.</em>
    </div>
  </div>
  
  <div *ngIf="isLoadingDocText | async" class="overlayText">
    <div class="spinnerText">
      <em>Please wait while we generate your document...</em>
    </div>
  </div>
  